export default "__VITE_ASSET__7ed0899c__"